export const executeCallbackOnEnter =
  (callback: () => void) =>
  (event: React.KeyboardEvent<HTMLDivElement>): void => {
    if (event.keyCode === 13) {
      callback();
    }
  };
